import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Box,
  TextareaAutosize,
} from "@mui/material";
import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";
import Cropper from "react-easy-crop";
import Slider from "@mui/material/Slider";
import getCroppedImg from "./getCroppedImg"; // Helper function for cropping (see below)

const BlogForm = () => {
  const [formData, setFormData] = useState({
    title_name: "",
    views: "",
    likes: "",
    tags: "",
    short_description: "",
    contents: "",
    author_name: "",
    type: "",
    is_featured: "",
    created_at: "",
    updated_at: "",
  });

  const [image, setImage] = useState(null);
  const [croppedArea, setCroppedArea] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedImage, setCroppedImage] = useState(null);
  const [aspectRatio, setAspectRatio] = useState(1); // Aspect ratio control

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setImage(reader.result);
      };
    }
  };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedArea(croppedAreaPixels);
  };

  const handleCrop = async () => {
    try {
      const croppedImg = await getCroppedImg(image, croppedArea);
      setCroppedImage(croppedImg);
      alert("Image cropped successfully!");
    } catch (error) {
      console.error("Crop error:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    console.log(formDataToSend);
    for (const key in formData) {
      formDataToSend.append(key, formData[key]);
    }
    if (croppedImage) formDataToSend.append("blogImage", croppedImage);

    try {
      const response = await fetch(
        "http://localhost:3030/api/blog/blogadderwithimage",
        {
          method: "POST",
          body: formDataToSend,
        }
      );

      const result = await response.json();
      if (response.ok) {
        alert(result.message);
      } else {
        alert(result.message);
      }
    } catch (error) {
      console.error("Error adding recipe:", error);
      alert("Error adding recipe, try again later.");
    }
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Add Blog
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {/* Form Fields */}

          {/* Recipe Title */}
          <Grid item xs={12} md={6}>
            <TextField
              label="Title"
              variant="outlined"
              fullWidth
              name="title_name"
              value={formData.title_name}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Views"
              variant="outlined"
              fullWidth
              name="views"
              value={formData.views}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Likes"
              variant="outlined"
              fullWidth
              name="likes"
              value={formData.likes}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* tags */}
          <Grid item xs={12} md={6}>
            <TextField
              label="Tags"
              variant="outlined"
              fullWidth
              name="tags"
              value={formData.tags}
              onChange={handleChange}
            />
          </Grid>

          {/* Short Description */}
          <Grid item xs={12} md={6}>
            <TextField
              label="Short Description"
              variant="outlined"
              fullWidth
              name="short_description"
              value={formData.short_description}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* Equipment Recipe ID */}
          <Grid item xs={12} md={6}>
            <TextField
              label="contents"
              variant="outlined"
              fullWidth
              name="contents"
              value={formData.contents}
              onChange={handleChange}
            />
          </Grid>

          {/* Author Name */}
          <Grid item xs={12} md={6}>
            <TextField
              label="Author Name"
              variant="outlined"
              fullWidth
              name="author_name"
              value={formData.author_name}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* Type*/}
          <Grid item xs={12} md={6}>
            <TextField
              label="Type"
              variant="outlined"
              fullWidth
              name="type"
              value={formData.type}
              onChange={handleChange}
            />
          </Grid>

          {/* Created At */}
          <Grid item xs={12} md={6}>
            <TextField
              label="Created At"
              variant="outlined"
              fullWidth
              name="created_at"
              value={formData.created_at}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* Updated At */}
          <Grid item xs={12} md={6}>
            <TextField
              label="Updated At"
              variant="outlined"
              fullWidth
              name="updated_at"
              value={formData.updated_at}
              onChange={handleChange}
            />
          </Grid>

          {/* Featured */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Is Featured?"
              name="is_featured"
              value={formData.is_featured}
              onChange={handleChange}
            />
          </Grid>

          <Box sx={{ mb: 2 }}>
            <TextField
              type="file"
              fullWidth
              InputLabelProps={{ shrink: true }}
              onChange={handleImageChange}
            />
          </Box>

          {/* Aspect Ratio Slider */}
          <Box sx={{ mb: 2 }}>
            <Typography>Aspect Ratio: {aspectRatio}</Typography>
            <Slider
              value={aspectRatio}
              min={0.1}
              max={3}
              step={0.1}
              onChange={(e, newValue) => setAspectRatio(newValue)}
            />
          </Box>

          {/* Other fields... */}

          {/* Image Upload */}
          <Grid item xs={12}>
            <Button
              variant="contained"
              component="label"
              startIcon={<CloudUploadIcon />}
            >
              Upload Recipe Image
              <input type="file" hidden onChange={handleImageChange} />
            </Button>
          </Grid>

          {/* Image Cropper */}
          {image && (
            <Box
              sx={{
                marginTop: 3,
                position: "relative",
                height: 300,
                width: 300,
              }}
            >
              <Cropper
                image={image}
                crop={crop}
                zoom={zoom}
                aspect={aspectRatio} // Set aspect ratio
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
              />
              <Slider
                value={zoom}
                min={1}
                max={3}
                step={0.1}
                aria-labelledby="Zoom"
                onChange={(e, zoom) => setZoom(zoom)}
                sx={{ marginTop: 2 }}
              />
              <Button
                variant="contained"
                color="secondary"
                onClick={handleCrop}
                sx={{ marginTop: 2 }}
              >
                Crop Image
              </Button>
            </Box>
          )}

          {/* Submit Button */}
          <Grid item xs={12}>
            <Button variant="contained" color="primary" type="submit">
              Add Recipe
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default BlogForm;
